class AuthAttributeFetcher {
  public authElement = document.getElementById('params');

  public getAuthValue = (param: string) => {
    return this.authElement ? this.authElement.getAttribute(param) : null;
  };
}

export const authAttributeFetcher = new AuthAttributeFetcher();

export const AUTH_ATTRIBUTE = Object.freeze({
  emailId: authAttributeFetcher.getAuthValue('emailid'),
  customerId: authAttributeFetcher.getAuthValue('customerid'),
  customerName: authAttributeFetcher.getAuthValue('customername'),
});

/**
 * To be used in App level components, where AuthContext cannot be accessed.
 * Else recommended to fetch the clientId from AuthContext.
 */
export const isMonsContext: boolean = !authAttributeFetcher.authElement
  ? true
  : false;

/**
 * To be used in App level components, where AuthContext cannot be accessed.
 * Else recommended to fetch the clientId from AuthContext.
 */
export const isRegulatorCentralApp: boolean = !isMonsContext;

/**
 * To be used in App level components, where AuthContext cannot be accessed.
 * Else recommended to fetch the isAnonymousUser from AuthContext.
 * Only valid in Public Facing Portal served using Compliance Central.
 */
export const isAnonymousUser: boolean =
  isRegulatorCentralApp && !AUTH_ATTRIBUTE.customerId;
